export const htmlDefaultValues = {
  name: 'WPP Open Platform',
  title: 'Welcome to WPP Open Platform',
  description:
    'WPP Open is WPP’s intelligent marketing operating system powered by AI. Applying WPP’s decades of experience serving enterprise clients, WPP Open is designed to integrate with any client, partner or technology vendor to create optimised and automated marketing capabilities.',
  faviconHref: 'assets/wpp-favicon.ico',
}
